import { takeLatest, call, select, put } from 'redux-saga/effects';

import service from 'services/customInterrogationService';

import { selectors as sessionSelectors } from 'store/session';

import { init, create, createModal, types } from './actions';

export default function* root() {
  yield takeLatest(
    types.CREATE_CUSTOM_INTERROGATION_REQUEST,
    watchCreateCustomInterrogation,
  );
}

export function* initCustomInterrogationListPage() {
  const groupId = yield select(sessionSelectors.getGroupId);
  const customInterrogations = yield call(service.list, groupId);
  yield put(init({ customInterrogations }));
}

function* watchCreateCustomInterrogation(action) {
  const groupId = yield select(sessionSelectors.getGroupId);
  const { name, task } = action.payload;
  try {
    const customInterrogation = yield call(service.create, groupId, {
      name,
      task,
    });
    yield put(create.success({ customInterrogation }));
    yield put(createModal.close());
  } catch (error) {
    yield put(create.error(error));
  }
}
